import { OrderStatusRollup } from "@/features/marketplace/components/orders-list/OrderStatusRollup";
import { StatusPill } from "@/features/marketplace/components/orders-list/StatusMenu";
import { usesVideoStatusChips } from "@/features/marketplace/lib/line-status-display";
import type { MarketplaceFulfillmentViewer } from "@/features/marketplace/lib/fulfillment-badge-variant";
import {
  describeVideoStatusRollup,
  scriptRowDisplayFulfillmentStatus,
} from "@/features/marketplace/lib/video-display-status";
import type { OrderScriptRow } from "@/features/marketplace/types/marketplace.types";

export function VideoStatusSummary({
  script,
  viewer = "partner",
}: {
  script: Pick<
    OrderScriptRow,
    "fulfillmentStatus" | "videos" | "videoStatusCounts"
  >;
  viewer?: MarketplaceFulfillmentViewer;
}) {
  if (!usesVideoStatusChips(script)) {
    return (
      <StatusPill
        status={scriptRowDisplayFulfillmentStatus(script)}
        viewer={viewer}
      />
    );
  }

  return <OrderStatusRollup rollup={describeVideoStatusRollup(script)} />;
}
